import { createSelector } from 'reselect';

import { returnJS } from 'utils/helpers';

import { initialState } from './reducer';

/**
 * Direct selector to the patientSchedule state domain
 */

const selectPatientScheduleDomain = (state) =>
	state.get('patientSchedule', initialState);

const makeSelectPatientSchedule = () =>
	createSelector(selectPatientScheduleDomain, (substate) => returnJS(substate));

const makeSelectEvents = () =>
	createSelector(selectPatientScheduleDomain, (substate) =>
		returnJS(substate.get('events')),
	);

const makeSelectLoading = () =>
	createSelector(selectPatientScheduleDomain, (substate) =>
		substate.get('loading'),
	);

const makeSelectError = () =>
	createSelector(selectPatientScheduleDomain, (substate) =>
		returnJS(substate.get('error')),
	);

const makeSelectProfileError = () =>
	createSelector(selectPatientScheduleDomain, (substate) =>
		returnJS(substate.get('profileError')),
	);

const makeSelectSubscribeUrls = () =>
	createSelector(selectPatientScheduleDomain, (substate) =>
		returnJS(substate.get('subscribeUrls')),
	);

export default makeSelectPatientSchedule;
export {
	selectPatientScheduleDomain,
	makeSelectEvents,
	makeSelectLoading,
	makeSelectError,
	makeSelectProfileError,
	makeSelectSubscribeUrls,
};
